// extracted by mini-css-extract-plugin
export default {"backIcon":"JP_NewsDetail_backIcon__gMEE-"};